module.exports = __webpack_public_path__ + "img/minting-shape1.11e028bd.png";